import { TruktTmsApi } from '@trukt/tms-api';

export const truktTmsApi = new TruktTmsApi({
  baseURL: process.env.TRUKT_API_BASE_URL,
});
